import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Grid, Stack, TextField } from "@mui/material";
import StepLayout from "../../components/StepLayout/StepLayout";
import { useTunnelDispatch } from "../../context/TunnelContext";
import { BRANDS } from "../../utils/mockData";
import { connectPrinter, getAuthorizedPrinter, sendToPrinter } from "../../utils/printer";

export default function BrandSelection() {
  const navigate = useNavigate();
  const dispatch = useTunnelDispatch();
  const [otherBrand, setOtherBrand] = useState("");

  function selectBrand(brand) {
    dispatch({ type: "SET_BRAND", brand });
    navigate("/nouvelle-demande/modele");
  }

  function submitOtherBrand() {
    if (!otherBrand.trim()) {
      return;
    }
    selectBrand(otherBrand.trim());
  }

  function test() {
    connectPrinter().then((device) => {
      if (!device) {
        console.warn("No printer connected.");
        return;
      }
      console.log("Printer connected:", device);
      getAuthorizedPrinter().then((device) => {
        if (!device) {
          console.warn("No authorized printer found.");
          return;
        }

        sendToPrinter(device).catch((error) => {
          console.error("Error sending to printer:", error);
        });
      });
    });
  }

  return (
    <StepLayout title="Marque du chausson">
      <Grid container spacing={2} sx={{ mb: 4 }}>
        {BRANDS.map((brand) => (
          <Grid item xs={6} sm={4} md={3} key={brand}>
            <Button
              fullWidth
              variant="outlined"
              size="large"
              onClick={() => selectBrand(brand)}
            >
              {brand}
            </Button>
          </Grid>
        ))}
      </Grid>
      <Stack direction="row" spacing={2} sx={{ maxWidth: 480 }}>
        <TextField
          fullWidth
          label="Autre marque"
          value={otherBrand}
          onChange={(e) => setOtherBrand(e.target.value)}
        />
        <Button variant="contained" onClick={submitOtherBrand}>
          Valider
        </Button>
      </Stack>
      <Button variant="contained" onClick={test} sx={{ mt: 4 }}>
          TEST
        </Button>
    </StepLayout>
  );
}
